import { STAGE_META, formatStamp, stageEnteredAt, visualStage } from "../../lib/complaints";

// Simplified to the three stages that matter at a glance: Logged, Under
// Review, Resolved. The real lifecycle still has five (in_progress sits
// inside Under Review; closed sits inside Resolved) -- this tracker is a
// clean summary of it, not a replacement for the full timeline below it.
const VISUAL_STAGES = ["logged", "under_review", "resolved"];

// The time each visual step was last entered — falls back to the collapsed
// stage's own entry time when the complaint skipped straight past it (e.g.
// closed early with no separate "resolved" entry).
function visualEnteredAt(history, stage) {
  if (stage === "under_review") {
    return stageEnteredAt(history, "under_review") || stageEnteredAt(history, "in_progress");
  }
  if (stage === "resolved") {
    return stageEnteredAt(history, "resolved") || stageEnteredAt(history, "closed");
  }
  return stageEnteredAt(history, "logged");
}

export default function ComplaintStageTracker({ complaint }) {
  const current = VISUAL_STAGES.indexOf(visualStage(complaint.stage));
  // Green once it is resolved, red while it is still open.
  const reachedColor = VISUAL_STAGES[current] === "resolved" ? "var(--pine)" : "var(--brick)";

  return (
    <ol
      className="m-0 mt-1 grid list-none grid-cols-[repeat(3,minmax(0,1fr))] gap-[6px] p-0 text-[13px]"
      data-testid={`complaint-tracker-${complaint.complaint_no}`}
    >
      {VISUAL_STAGES.map((stage, i) => {
        const reached = i <= current;
        const isCurrent = i === current;
        // Only the current step's date shows -- three stamped dates in a
        // narrow sidebar was more clutter than signal; the one that's
        // actually live is the one worth a glance.
        const at = isCurrent ? visualEnteredAt(complaint.history, stage) : null;

        return (
          <li key={stage} className="flex min-w-0 flex-col gap-[6px]" aria-current={isCurrent ? "step" : undefined}>
            <i className="block h-1 rounded-sm bg-msd-line" style={reached ? { background: reachedColor } : undefined} />
            <div className="min-w-0">
              <div className={isCurrent ? "font-semibold" : "text-msd-muted"}>{STAGE_META[stage].label}</div>
              {at && <div className="text-[12px] tabular-nums text-msd-muted">{formatStamp(at)}</div>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
